import React, { Component } from 'react';

export default class Consultorio extends Component {

    render() {
        return ( 
        <div>
                        <div className="gray-bg-semi-dark" id="consultorio" >
                        <div className="boletin__section">
                            <div className="row boletin__title-row">
                            <div className="col-sm-12  boletin__title-name-section">
                                <span className=" boletin__title-name">CONSULTORIO</span>
                            </div>
                            </div>
                            <div className="row">
                            <div className="col-sm-12 text-center">
                                <div className="consultorio__description-section">
                                <p className="consultorio__description-text">  
                                    Día a día recibimos consultas muy interesantes y compartimos información que puede ser muy relevante para todos los exportadores. Por ello hemos decidido recopilaras y compartir las mejores de la semana
                                </p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="gray-bg-light-2" id="consultorio" >
                            <div
                            id="carouselOtherNewsIndicators"
                            className="carousel slide"
                            data-ride="carousel"
                            data-touch="true"
                          >
                          <div className="boletin__section">

                            <ol className="carousel-indicators">
                              <li
                                data-target="#carouselOtherNewsIndicators"
                                data-slide-to="0"
                                className="active"
                              ></li>
                              <li
                                data-target="#carouselOtherNewsIndicators"
                                data-slide-to="1"
                              ></li>
                            </ol>
                            <div className="carousel-inner">
                              <div className="carousel-item active">
                                <div className="row">
                                  <div className="col-sm-6">
                                      <p className="other-news__title">
                                          ¿Cómo afecta el acuerdo de alianza del pacífico al sector de textil?
                                      </p>
                                      <div className="other-news__extract">
                                          <p className="other-news__extract-text">
                                            Un tratado de libre comercio (TLC) es un acuerdo comercial vinculante que suscriben dos o más países para 
                                            acordar la concesión de preferencias arancelarias mutuas y la reducción de barreras no arancelarias al 
                                            comercio de bienes y servicios. A fin de profundizar la integración económica de los países firmantes, 
                                            un TLC incorpora además de los temas de acceso a nuevos mercados, otros aspectos normativos relacionados 
                                            al comercio, tales como propiedad intelectual, inversiones, políticas de competencia, servicios financieros, 
                                            telecomunicaciones, comercio electrónico, asuntos laborales, disposiciones medioambientales y mecanismos de 
                                            defensa comercial y de solución de controversias. Los TLC tienen un plazo indefinido, es decir, permanecen 
                                            vigentes a lo largo del tiempo por lo que tienen carácter de perpetuidad.
                                          </p>
                                          <p className="other-news__source">
                                              Fuente: Área de inteligencia de PromPerú
                                          </p>
                                      </div>
                                  </div>
                                  <div className="col-sm-6 showMin576">
                                      <p className="other-news__title">
                                          ¿Como puedo detectar una estafa?
                                      </p>
                                      <div className="other-news__extract">
                                          <p className="other-news__extract-text">
                                          Un tratado de libre comercio (TLC) es un acuerdo comercial vinculante que suscriben dos o más países para 
                                          acordar la concesión de preferencias arancelarias mutuas y la reducción de barreras no arancelarias al 
                                          comercio de bienes y servicios. A fin de profundizar la integración económica de los países firmantes, 
                                          un TLC incorpora además de los temas de acceso a nuevos mercados, otros aspectos normativos relacionados 
                                          al comercio, tales como propiedad intelectual, inversiones.
                                          </p>
                                          <p className="other-news__source">
                                              Fuente: <span className="other-news__source-name">Cámara de comercio</span>
                                          </p>
                                      </div>
                                  </div>
                                </div>
                              </div>
                              <div className="carousel-item">
                                  <div className="row">
                                    <div className="col-sm-6">
                                        <p className="other-news__title">
                                            ¿Cómo afecta el acuerdo de alianza del pacífico al sector de textil?
                                        </p>
                                        <div className="other-news__extract">
                                            <p className="other-news__extract-text">
                                              Un tratado de libre comercio (TLC) es un acuerdo comercial vinculante que suscriben dos o más países para 
                                              acordar la concesión de preferencias arancelarias mutuas y la reducción de barreras no arancelarias al 
                                              comercio de bienes y servicios. A fin de profundizar la integración económica de los países firmantes, 
                                              un TLC incorpora además de los temas de acceso a nuevos mercados, otros aspectos normativos relacionados 
                                              al comercio, tales como propiedad intelectual, inversiones, políticas de competencia, servicios financieros, 
                                              telecomunicaciones, comercio electrónico, asuntos laborales, disposiciones medioambientales y mecanismos de 
                                              defensa comercial y de solución de controversias. Los TLC tienen un plazo indefinido, es decir, permanecen 
                                              vigentes a lo largo del tiempo por lo que tienen carácter de perpetuidad.
                                            </p>
                                            <p className="other-news__source">
                                                Fuente: Área de inteligencia de PromPerú
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 showMin576">
                                        <p className="other-news__title">
                                            ¿Como puedo detectar una estafa?
                                        </p>
                                        <div className="other-news__extract">
                                            <p className="other-news__extract-text">
                                            Un tratado de libre comercio (TLC) es un acuerdo comercial vinculante que suscriben dos o más países para 
                                            acordar la concesión de preferencias arancelarias mutuas y la reducción de barreras no arancelarias al 
                                            comercio de bienes y servicios. A fin de profundizar la integración económica de los países firmantes, 
                                            un TLC incorpora además de los temas de acceso a nuevos mercados, otros aspectos normativos relacionados 
                                            al comercio, tales como propiedad intelectual, inversiones.
                                            </p>
                                            <p className="other-news__source">
                                                Fuente: <span className="other-news__source-name">Cámara de comercio</span>
                                            </p>
                                        </div>
                                    </div>
                                  </div>
                              </div>
                            </div>

                          </div>

                            <a className="carousel-control-prev" href="#carouselOtherNewsIndicators" role="button" data-slide="prev">
                                <div className="other-news__prev"><span className="carousel-control-prev-icon" aria-hidden="true"></span></div>
                                <span className="sr-only">Previous</span>
                              </a>
                              <a className="carousel-control-next" href="#carouselOtherNewsIndicators" role="button" data-slide="next">
                                  <div className="other-news__next"><span className="carousel-control-next-icon" aria-hidden="true"></span></div>
                                <span className="sr-only">Next</span>
                              </a>
                        </div>
                        
                      </div>
                      </div>
        )
    }

}